<div
    class="agpr-fullProfileDialog"
    [ngClass]="{'agpr-fullProfileDialog--fullPage': hideBackButton}"
    [@overlayAnimation]="overlayAnimation"
    (@overlayAnimation.start)="overlayAnimationStart($event)"
    [style.zIndex]="zIndex"
    [style.height]="panelHeight"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
>
    <div class="agpr-fullProfileDialog-container"
        [@slideInOutAnimation]="slideInOutAnimation"
        (@slideInOutAnimation.done)="animationDone($event)"
        [style.height]="panelHeight"
    >
        @if (!hideBackButton) {
            <agpr-button
                class="agpr-fullProfileDialog-focusClose"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-xmark"
                ariaLabel="close"
                (click)="closeAll()"
            ></agpr-button>
        }

        <div class="agpr-fullProfileDialog-center">
            <agpr-entity-full-profile
                #entityFullProfile
                [id]="key + '_' + entity?.id + '_entityFullProfile'"
                class="agpr-fullProfile"
                [entity]="entity"
                [backButtonLocalization]="backButtonLocalization"
                (exit)="close($event)"
                [contactPrivateData]="contactPrivateData"
                [outletPrivateData]="outletPrivateData"
                (showContactEditor)="showContactEditor()"
            >
            </agpr-entity-full-profile>
        </div>

        <aside
            class="agpr-fullProfileDialog-sidebar"
            [attr.aria-label]="'Common.layout.rhp' | localize"
        >
            <agpr-rhp-contexts
                [id]="key + '_rhpContext'"
                [fullHeightTakeover]="fullHeight"
                [hideBusinessCard]="true"
            >
                <!-- TO DO: Private Contacts 'eye tab' to be added in future release -->
                <!-- <agpr-tab
                    icon='fa-regular fa-eye'
                    tooltip="A dummy tab for proof of concept"
                ></agpr-tab> -->
            </agpr-rhp-contexts>
        </aside>
    </div>
</div>

<div
    *ngIf="contactEditorVisible"
    class="agpr-contactEditor-overlay"
    [@fade]="contactEditorVisible"
    [style.zIndex]="contactEditorZIndex"
    [style.height]="panelHeight"
>
    <agpr-contact-editor
        (hideContactEditor)="onContactEditorClose($event)"
    ></agpr-contact-editor>
</div>
